import React from 'react';
import { APP_COLORS as C, APP_FONT as F } from '../tokens';
import type { Suggestion } from '../types';

type Props = {
  suggestions: ReadonlyArray<Suggestion>;
  onSuggestionClick?: (s: Suggestion) => void;
};

function SuggestionIcon({ name }: { name: Suggestion['iconName'] }) {
  const common = {
    width: 18, height: 18, fill: 'none', stroke: '#fff', strokeWidth: 2.2,
    strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const,
  };
  switch (name) {
    case 'bank':
      return <svg viewBox="0 0 24 24" {...common}><line x1="3" y1="22" x2="21" y2="22"/><line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/><line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/><polygon points="12 2 20 7 4 7"/></svg>;
    case 'send':
      return <svg viewBox="0 0 24 24" {...common}><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>;
    case 'report':
      return <svg viewBox="0 0 24 24" {...common}><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="3" y1="20" x2="21" y2="20"/></svg>;
    default:
      return null;
  }
}

export default function Suggestions({ suggestions, onSuggestionClick }: Props) {
  return (
    <div style={{
      background: 'linear-gradient(135deg, ' + C.teal + ' 0%, ' + C.tealDark + ' 100%)',
      color: '#fff',
      borderRadius: 14,
      padding: '20px 22px',
      fontFamily: F.family,
    }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, margin: '0 0 4px', color: '#fff' }}>
        Suggestions for you
      </h3>
      <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)', marginBottom: 16 }}>
        Based on your business activity
      </div>

      {suggestions.length === 0 ? (
        <div style={{ fontSize: 12.5, color: 'rgba(255,255,255,0.7)', fontStyle: 'italic' }}>
          No suggestions right now. Great job keeping on top of things.
        </div>
      ) : (
        suggestions.map((s) => (
          <div
            key={s.id}
            onClick={() => onSuggestionClick?.(s)}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: 10,
              padding: '12px 14px',
              marginBottom: 10,
              cursor: 'pointer',
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 2, display: 'flex', alignItems: 'center', gap: 8 }}>
              <SuggestionIcon name={s.iconName} />
              {s.title}
            </div>
            <div style={{ fontSize: 11.5, color: 'rgba(255,255,255,0.75)', marginLeft: 26 }}>
              {s.description}
            </div>
          </div>
        ))
      )}
    </div>
  );
}
